import API from "./index";
import Endpoints from "./endpoints";
import { cifrarAES } from "../../utils/cryptoAES";
import {
  dispararErroSistema,
  erroJaTratado,
  marcarErroSistemaTratado,
  showSystemErrorModal,
} from "../../utils/systemError";

// Handshake do token público (ms-usuario) — ver doc "Integração do token
// público — área não logada". Reaproveita o orquestrador de cifra
// (utils/cryptoAES), mas com chave própria — não é a mesma do header
// X-Id-Usuario-Criptografado.

const APLICACAO_WEB = "TEUCARD-WEB";

function getChaveTokenPublico(): string {
  const chave = process.env.REACT_APP_TOKEN_PUBLICO_KEY;

  if (!chave) {
    dispararErroSistema(
      "Aplicação não configurada corretamente (chave do token público ausente). Procure o suporte técnico.",
    );
  }

  return chave;
}

// Renova a 80% do tempo de vida do token, nunca esperando o 401 (recomendação do doc).
const FATOR_RENOVACAO_ANTECIPADA = 0.8;

type TokenPublicoResponse = {
  accessToken: string;
  expiresIn: number;
  tokenType: string;
};

let tokenCache: { accessToken: string; renovarApos: number } | null = null;
let requisicaoEmAndamento: Promise<string> | null = null;

async function solicitarNovoToken(): Promise<string> {
  const payload = { aplicacao: cifrarAES(APLICACAO_WEB, getChaveTokenPublico()) };

  try {
    const response = await API.post<TokenPublicoResponse>(
      Endpoints.usuario.tokenPublico,
      payload,
    );

    const { accessToken, expiresIn } = response.data;
    tokenCache = {
      accessToken,
      renovarApos: Date.now() + expiresIn * 1000 * FATOR_RENOVACAO_ANTECIPADA,
    };

    return accessToken;
  } catch (error) {
    // 401/403 (fora do horario funcional) ja mostrou sua propria mensagem no
    // interceptor do axios (services/api/index.ts) — nao duplica aqui.
    if (!erroJaTratado(error)) {
      showSystemErrorModal(
        "Não foi possível obter autorização para continuar. Tente novamente em instantes.",
      );
      marcarErroSistemaTratado(error);
    }
    throw error;
  }
}

export async function getPublicToken(): Promise<string> {
  if (tokenCache && Date.now() < tokenCache.renovarApos) {
    return tokenCache.accessToken;
  }

  if (!requisicaoEmAndamento) {
    requisicaoEmAndamento = solicitarNovoToken().finally(() => {
      requisicaoEmAndamento = null;
    });
  }

  return requisicaoEmAndamento;
}
